import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";

/**
 * Asynchronously retrieves the current browser fingerprint.
 *
 * @returns {Promise<string>} A promise that resolves to a string representing the browser's fingerprint.
 */

export const getBrowserFingerPrint = async () =>
  await getCurrentBrowserFingerPrint();
